import { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

interface NavbarMobileProps {
  isScrolled: boolean;
  variant?: "light" | "dark";
}

export function NavbarMobile({ isScrolled, variant = "light" }: NavbarMobileProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const iconColor = !isScrolled && variant === "dark" ? "text-white" : "text-drcash-maastricht-blue";

  const scrollToPlanos = () => {
    const hasPlansSection = ['/', '/boleto-parcelado', '/antecipacao'].includes(location.pathname);
    
    if (!hasPlansSection) {
      navigate('/');
      setTimeout(() => {
        const planosSection = document.getElementById('planos');
        if (planosSection) {
          planosSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const planosSection = document.getElementById('planos');
      if (planosSection) {
        planosSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="md:hidden">
      <button
        className={`p-2 ${iconColor} focus:outline-none`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
        aria-expanded={isMenuOpen}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-lg py-4">
          <div className="container mx-auto px-4">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="font-medium text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <div className="relative group">
                <button
                  type="button"
                  className="w-full text-left font-medium text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors py-2 flex items-center justify-between"
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                  aria-expanded={isServicesOpen}
                >
                  <span>Serviços</span>
                  <ChevronDown
                    className={`w-4 h-4 transform transition-transform ${
                      isServicesOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isServicesOpen && (
                  <div className="pl-4 flex flex-col border-l border-drcash-tiffany-blue space-y-2">
                    <Link
                      to="/boleto-parcelado"
                      className="block text-drcash-maastricht-blue hover:text-drcash-caribbean-green py-2"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Boleto parcelado
                    </Link>
                    <Link
                      to="/antecipacao"
                      className="block text-drcash-maastricht-blue hover:text-drcash-caribbean-green py-2"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Antecipação de cartão de crédito
                    </Link>
                  </div>
                )}
              </div>
              <Link
                to="/atendimento"
                className="block font-medium text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Atendimento
              </Link>
              <button
                onClick={scrollToPlanos}
                className="block text-left font-medium text-drcash-maastricht-blue hover:text-drcash-caribbean-green transition-colors py-2"
              >
                Preços
              </button>
              <Link
                to="/acesse-portais"
                className="btn-primary text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Acesso Clínicas
              </Link>
            </nav>
          </div>
        </div>
      )}
    </div>
  );
}
